import { getColors, makeBlankBackground, makeGradientBackgroundCss } from '../constants/background';
import { BLANK } from '../constants/useOptions';
export const getBackground = ({
  use,
  theme
}) => use === BLANK ? makeBlankBackground({
  theme
}) : makeGradientBackgroundCss(getColors({
  use,
  theme
}));